import React from 'react';
import { motion } from 'framer-motion';

const WalletTransaction = () => {
  const transactions = [
    { id: 'TNX101', user: 'Favour', type: 'Wallet Top-up', amount: '₦5,000', method: 'wallet', date: 'Apr 10, 2025', status: 'Success' },
    { id: 'TNX102', user: 'Joy', type: 'Ticket Payment', amount: '₦5,000', method: 'Firstbank', date: 'Apr 10, 2025', status: 'Success' },
    { id: 'TNX103', user: 'Victoria', type: 'Ticket Payment', amount: '₦5,000', method: 'Paystack', date: 'Apr 10, 2025', status: 'Success' },
  ];

  const overview = [
    { user: 'Favour Favour', balance: '₦5,000', accountNumber: '3400180812', coins: 120, lastActivity: 'April 10, 2025', status: 'Active' },
    { user: 'Favour Favour', balance: '₦5,000', accountNumber: '3400180812', coins: 120, lastActivity: 'April 10, 2025', status: 'Active' },
  ];

  return (
    <div className="max-w-6xl mx-auto p-5">
      <h1 className="text-2xl font-bold mb-5">Wallet & Transaction</h1>

      <div className="tabs mb-5">
        <button className="tab active">Transactions</button>
        <button className="tab">Wallet Overview</button>
      </div>

      <motion.div
        className="overflow-hidden shadow-md rounded-lg mb-5"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-xl font-semibold p-4 border-b">Transactions</h2>
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2">Transaction ID</th>
              <th className="p-2">User</th>
              <th className="p-2">Type (Wallet/Ticket)</th>
              <th className="p-2">Amount</th>
              <th className="p-2">Method</th>
              <th className="p-2">Date</th>
              <th className="p-2">Status</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((transaction, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="p-2">{transaction.id}</td>
                <td className="p-2">{transaction.user}</td>
                <td className="p-2">{transaction.type}</td>
                <td className="p-2">{transaction.amount}</td>
                <td className="p-2">{transaction.method}</td>
                <td className="p-2">{transaction.date}</td>
                <td className="p-2">{transaction.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>

      <motion.div
        className="overflow-hidden shadow-md rounded-lg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-xl font-semibold p-4 border-b">Wallet Overview</h2>
        <table className="min-w-full">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2">User Name</th>
              <th className="p-2">Wallet Balance</th>
              <th className="p-2">Account Number</th>
              <th className="p-2">Coins</th>
              <th className="p-2">Last Activity</th>
              <th className="p-2">Status</th>
              <th className="p-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {overview.map((item, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="p-2">{item.user}</td>
                <td className="p-2">{item.balance}</td>
                <td className="p-2">{item.accountNumber}</td>
                <td className="p-2">{item.coins}</td>
                <td className="p-2">{item.lastActivity}</td>
                <td className="p-2">{item.status}</td>
                <td className="p-2">
                  <button className="text-blue-500 hover:underline">View/Edit</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </div>
  );
};

export default WalletTransaction;